import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import logo from '../images/logo.png';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-gray-100 dark:bg-black border-t border-gray-300 dark:border-gray-800 py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src={logo} 
                alt="Chata Barvinok Logo" 
                className="h-10 w-10 object-contain dark:brightness-0 dark:invert"
              />
              <span className="text-gray-900 dark:text-white font-bold text-lg tracking-wide">CHATA BARVINOK</span>
            </div>
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              {t('home.footer.description')}
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-4 uppercase tracking-wide">{t('home.footer.navigation')}</h4>
            <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
              <li>
                <Link to="/" className="hover:text-silver-300 transition-colors uppercase tracking-wide">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/ubytovanie" className="hover:text-silver-300 transition-colors uppercase tracking-wide">
                  {t('nav.accommodation')}
                </Link>
              </li>
              <li>
                <Link to="/rezort" className="hover:text-silver-300 transition-colors uppercase tracking-wide">
                  {t('nav.resort')}
                </Link>
              </li>
              <li>
                <Link to="/galeria" className="hover:text-silver-300 transition-colors uppercase tracking-wide">
                  {t('nav.gallery')}
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-silver-300 transition-colors uppercase tracking-wide">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-4 uppercase tracking-wide">{t('home.footer.contact')}</h4>
            <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
              <li className="flex items-center space-x-2">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span>+421 950 754 495</span>
              </li>
              <li className="flex items-center space-x-2">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span>chatabarvinok@gmail.com</span>
              </li>
              <li className="flex items-center space-x-2">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>065 31 Litmanová 328, Slovensko</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-300 dark:border-gray-800 pt-8 text-center text-sm text-gray-600 dark:text-gray-500">
          © {new Date().getFullYear()} Chata Barvinok. {t('home.footer.rights')}
        </div>
      </div>
    </footer>
  );
};

export default Footer;

